import PropTypes from 'prop-types';
import React from 'react';
import { Flex, Label } from 'rebass';
import { Translate } from 'react-redux-i18n';
import { PvBox, PvButtonOutlineRed, ErrorLabel } from 'styles/CustomComponents';
import { PvSelect } from '../../components/form/PvSelect';
import { PvClockInput} from "../../components/form/PvClockInput";

const LessonPause = ({lessonPauseTypes, selectedPauseType, pauseStartTime, pauseEndTime, removeLessonPause, updateLessonPause, id, generalLoading, errors}) => {

  const pauseTypeSelections = lessonPauseTypes.map((pauseType) => {
    return {value: pauseType, label: <Translate value={`driving_lesson.${pauseType.toLowerCase()}`} />}
  });

  return (
    <PvBox w={1}>
      <Flex flexWrap='wrap' alignItems='flex-end'>
        <PvBox display='inline-block' px={2} pb={3} w={[1, 1, 3/8]}>
          <ErrorLabel mb={2} error={errors.selectedPauseType}>
            <Translate value='driving_lesson.lesson_pause_type' /> *
          </ErrorLabel>
          <PvSelect
            placeholder=''
            options={pauseTypeSelections}
            value={{value: selectedPauseType, label: <Translate value={`driving_lesson.${selectedPauseType.toLowerCase()}`} /> }}
            onChange={(option) => updateLessonPause(id, {selectedPauseType: option.value, errors: errors})}
            isLoading={generalLoading}
          />
        </PvBox>
        <PvBox  display='inline-block' px={2} pb={3} w={[1/3, 1/4, 1/7]}>
          <ErrorLabel mb={2} error={errors.pauseStartTime}>
            <Translate value='driving_lesson.pause_start_time' /> *
          </ErrorLabel>
          <PvClockInput value={pauseStartTime}
            onChangeFn={(time) => updateLessonPause(id, {pauseStartTime: time, errors: errors})} />
        </PvBox>
        <Label display='inline-block' pb={30}>
          -
        </Label>
        <PvBox display='inline-block' px={2} pb={3} w={[1/3, 1/4, 1/7]}>
          <ErrorLabel mb={2} error={errors.pauseEndTime}>
            <Translate value='driving_lesson.pause_end_time' /> *
          </ErrorLabel>
          <PvClockInput value={pauseEndTime}
            onChangeFn={(time) => updateLessonPause(id, {pauseEndTime: time, errors: errors})} />
        </PvBox>
        <PvBox display='inline-block' px={2} pb={3}>
          <PvButtonOutlineRed onClick={() => removeLessonPause(id)}>
              <Translate value='driving_lesson.remove_lesson_pause' />
          </PvButtonOutlineRed>
        </PvBox>
      </Flex>
    </PvBox>
  );
};
  
LessonPause.propTypes = {
  lessonPauseTypes: PropTypes.array,
  selectedPauseType: PropTypes.string,
  pauseStartTime: PropTypes.string,
  pauseEndTime: PropTypes.string,
  removeLessonPause: PropTypes.func,
  updateLessonPause: PropTypes.func,
  generalLoading: PropTypes.bool,
  errors: PropTypes.object
};
  
export default LessonPause;


// WEBPACK FOOTER //
// ./src/containers/driving/LessonPause.jsx